<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import JoditVue from '@components/jodit/jodit-vue'
import SettingUserApi from '@api/core/users'
import RoleApi from '@api/core/roles'
import Multiselect from 'vue-multiselect'

export default {
  page: {
    title: 'Uživatelé',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, JoditVue, Multiselect },
  data() {
    return {
      id: null,
      isRoleEditReadOnly: false,
      isReadOnly: true,
      editMode: false,
      heading: this.$route.params.id !== undefined ? "Editace uživatele" : "Nový uživatelcd",
      roles: [],
      roleNamesOptionsSelected: [],
      isUserActivationAllowed: false,
      userForm: {
        name: '',
        surname: '',
        userName: '',
        emailAddress: '',
        creationTime: null,
        lastLoginTime: null,
        password: '',
        passwordConfirm: '',
        roleNames: [],
        isActive: false,
      },
    }
  },
  computed: {
    roleNamesOptions(){
        return this.roles.map(role => { return {name: role.displayName, value: role.normalizedName }});
    },
    roleNamesOptionsSelectedButNoAllowed() {
        return this.userForm.roleNames.filter( roleName => this.roleNamesOptionsSelected.find( option => option.value == roleName) == undefined);
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.id = this.$route.params.id
      this.editMode = this.id !== undefined

      if (this.editMode) {
        SettingUserApi.get(this.id)
          .then((response) => {
            this.userForm = response.data.result;
            this.fetchAllRoles().then(response => {
              this.roles = response.data.result;
              this.roleNamesOptionsSelected = this.roleNamesOptions.filter(option => this.userForm.roleNames.find( roleName => roleName === option.value) != undefined);
            })
          })

          .catch((e) => {
            console.error(e)
            this.$swal({
              title: this.L('base_result_Error'),
              text: this.L('base_info_loaditem_error'),
              type: 'error',
            })
            this.$router.push({ name: 'settingUsers' })
          })
          .finally(() => {
            this.init = true
          })
      } else {
        this.fetchAllRoles().then(response => {
          this.roles = response.data.result;
        })
      }
    },
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (!result) return

        let formData = Object.assign({}, this.userForm)
        formData.roleNames = this.roleNamesOptionsSelected.map(x=>x.value);

        if (this.editMode) {
            SettingUserApi.update(formData).then(() => {
              this.$toasted.success('Uživatel byl úspěšně uložen!', {
                theme: 'toasted-primary',
                position: 'bottom-right',
                duration: 5000,
              })
            });
        } else {
            SettingUserApi.create(formData).then(() => {
              this.$router.go(-1);
              this.$toasted.success('Uživatel byl úspěšně vytvořen!', {
                theme: 'toasted-primary',
                position: 'bottom-right',
                duration: 5000,
              })
          });
        }
      });
    },
    onReset() {},
    fetchAllRoles(){
      return RoleApi.getAllRoles();
    },
  },
}
</script>

<template>
  <Layout>
    <div slot="heading">
      <h1>Uživatelé</h1>
      <router-link :to="{ name: 'settingUsers' }" class="btn btn-second">zpět na seznam</router-link>
    </div>
    <div slot="tools">
      <b-button @click.prevent="onSubmit" class="btn btn-first">
        <font-awesome-icon :icon="['fas', 'save']" class="icon alt"/>Uložit
      </b-button>
    </div>

    <div class="page-content">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="pillar-title"></h2>

            <b-form @submit.prevent="onSubmit" @reset="onReset">
              <b-card class="md-card" no-body>
                <b-tabs card>
                  <b-tab title="Základní nastavení" active>
                    <div class="row">
                      <div class="col-md-6">
                         <b-form-group class="required" label="Jméno" label-for="userName">
                          <b-form-input
                            placeholder="Jméno"
                            v-validate="{ required: true }"
                            v-model="userForm.name"
                            name="userName"
                            type="text"
                          ></b-form-input>
                          <b-form-invalid-feedback>{{ errors.first('userName') }}</b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group class="required" label="Příjmení" label-for="sureName">
                          <b-form-input
                            placeholder="Příjmení"
                            v-validate="{ required: true }"
                            v-model="userForm.surname"
                            name="sureName"
                            type="text"
                          ></b-form-input>
                          <b-form-invalid-feedback>{{ errors.first('sureName') }}</b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div class="col-sm-12">


                        <b-form-group class="required" label="Uživatelské jméno / přezdívka" label-for="userName">
                          <b-form-input
                            placeholder=""
                            v-validate="{ required: true }"
                            v-model="userForm.userName"
                            name="userName"
                            type="text"
                            :disabled="editMode && (userForm.userName === 'admin' || userForm.userName === 'systemadmin' )"
                          ></b-form-input>

                          <small 
                            v-if="editMode && (userForm.userName === 'admin' || userForm.userName === 'systemadmin')"
                            class="form-text text-muted"
                          >
                              Nelze měnit uživatelské jméno administrátora
                          </small>

                          <b-form-invalid-feedback>{{ errors.first('userName') }}</b-form-invalid-feedback>
                        </b-form-group>

                          <b-form-group label="E-mail" label-for="email">
                          <b-form-input
                            placeholder=""
                            v-model="userForm.emailAddress"
                            name="email"
                            type="text"
                          ></b-form-input>
                          <b-form-invalid-feedback>{{ errors.first('email') }}</b-form-invalid-feedback>
                        </b-form-group>

                     </div>

                      <div class="col-md-6">
                        <b-form-group label="Datum vytvoření" label-for="creationTime">
                          <b-input-group label="Datum vytvoření" label-for="creationTime">
                        
                              <flat-pickr
                                v-model="userForm.creationTime"   
                                :disabled="true" 
                                :config="{wrap: true}"                                     
                                class="form-control" 
                                placeholder=""               
                                name="creationTime">
                              </flat-pickr>
                    
                              <b-input-group-append>
                                <button class="btn btn-default" type="button" title="Toggle" data-toggle>
                                  <i class="fa fa-calendar">
                                    <span aria-hidden="true" class="sr-only">Toggle</span>
                                  </i>
                                </button>
                            </b-input-group-append>
                        </b-input-group>
                       </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group label="Poslední přihlášení" label-for="lastLoginTime">
                          <flat-pickr
                            v-model="userForm.lastLoginTime"   
                            :disabled="true"                                      
                            class="form-control" 
                            placeholder=""               
                            name="lastLoginTime">
                          </flat-pickr>
                        </b-form-group>
                      </div>

                      <div class="col-md-6" v-if="editMode == false">
                        <b-form-group label="Heslo" label-for="password">
                          <b-form-input
                            placeholder=""
                            v-model="userForm.password"
                            name="email"
                            type="text"
                          ></b-form-input>
                       </b-form-group>
                      </div>
                      <div class="col-md-6" v-if="editMode == false">
                        <b-form-group label="Potvrzení hesla" label-for="passwordConfirm">
                          <b-form-input
                            placeholder=""
                            v-model="userForm.passwordConfirm"
                            name="email"
                            type="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="col-md-12">

                        <b-form-group label="Učet je aktivní" label-for="userIsActive">
                          <b-form-checkbox 
                            id="userIsActive" 
                            name="userIsActive"
                            v-model="userForm.isActive">
                          </b-form-checkbox>
                        </b-form-group>

                        <b-form-group label="Role" label-for="roleNames">
                          <multiselect 
                              :options="roleNamesOptions"
                              v-model="roleNamesOptionsSelected"
                              :multiple="true"
                              :searchable="true"
                              :disabled="isRoleEditReadOnly"
                              track-by="value"
                              label="name" 
                              placeholder=""                                            
                              name="roleNames">
                          </multiselect>
                        </b-form-group>

                      </div>




                    </div>
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
